import { styled } from '@mui/material/styles';
import { Box } from '@sunwisesoftware/sunwise-ui';

export default styled(Box)(({ theme }) => ({
    '&::before': {
        backgroundColor:
            theme.palette.mode === 'dark' ? '#1B1C20' : '#eef5f5ff',
        borderTopLeftRadius: theme.shape.borderRadius,
        content: '""',
        display: 'block',
        height: '8px',
        width: '8px',
    },
    background: theme.palette.mode === 'dark' ? '#1B1C20' : '#002438',
    height: '8px',
    position: 'absolute',
    bottom: '-8px',
    width: '8px',
}));
